import { render } from "./DropBall.vue?vue&type=template&id=968ad590"
import script from "./DropBall.vue?vue&type=script&lang=js"
export * from "./DropBall.vue?vue&type=script&lang=js"
script.render = render

export default script